import _ from 'lodash';
import { SENT } from '../../constants/AnnouncementTypes/announcementTypes';
import { messageSectionDateFromSeconds } from '../../utils/time/time';

const processAnnouncementThread = (announcementsThread) => {
    const message = announcementsThread.Messages?.shift();
    const messageInfo = JSON.parse(message?.MessageText);
    const creator = announcementsThread?.UserStatus?.Creator || { ID: 0, Class: null };
    return {
        threadID: announcementsThread.ThreadID,
        creatorContactID: `${creator.Class}_${creator.ID}`,
        published: message.Created,
        priority: announcementsThread.UserStatus.Tag === 1 ? 'high' : 'all',
        acknowledgmentRequired: announcementsThread.UserStatus.Acknowledgment,
        viewableToRoles: announcementsThread.UserStatus.Roles,
        announcementType: SENT,
        acknowledged: announcementsThread.Acknowledged,
        ...messageInfo,
    };
};

// run on each message thread to transform raw server response to our expected state structure
export const processMessageThread = (messageThread) => {
    const { Messages, ThreadID, UserStatus } = messageThread;
    const messageSections = {};
    const userStatuses = {};
    const contacts = Object.keys(UserStatus);

    _.forIn(Messages, (messageInfo) => {
        const contactID = `${messageInfo.SenderClass}_${messageInfo.SenderID}`;
        const contactCheck = !!_.find(contacts, (user) => user === contactID);
        // add thread contact in case API returns incomplete UserStatus data
        if (!contactCheck) {
            contacts.push(contactID);
        }

        const sentDate = messageSectionDateFromSeconds(messageInfo.Created);
        // if messageSection for this date doesn't exist, create it
        if (!messageSections[sentDate]) {
            messageSections[sentDate] = {
                messageDate: sentDate,
                data: [],
            };
        }
        // add message info to messageSection
        messageSections[sentDate].data.push({
            id: messageInfo.ID,
            sentDate: messageInfo.Created,
            contactID: `${messageInfo.SenderClass}_${messageInfo.SenderID}`,
            message: messageInfo.MessageText,
            image: messageInfo.Attachment ? messageInfo.Attachment.pop().Path : '',
        });
    });

    // loop through complete contacts; sends back UserStatus & any contacts missing from the API
    contacts.forEach((user) => {
        userStatuses[user] = {
            lastReadId: UserStatus[user] ? UserStatus[user].LastReadID : 0,
            deletedMessages: UserStatus[user] ? UserStatus[user].HiddenMessages || [] : [],
            online: UserStatus[user] ? UserStatus[user].Online : false,
        };
    });

    return {
        threadID: ThreadID,
        messageSections,
        contacts,
        userStatuses,
    };
};

export const syncThreadsTransformer = (data) => {
    try {
        const payload = JSON.parse(data);
        const transformedPayload = {
            announcements: {},
            deletedAnnouncements: [],
            messages: {},
            deactivate: [],
        };

        _.forIn(payload.Announcements, (announcement, thread) => {
            if (announcement.UserStatus.Deleted) {
                transformedPayload.deletedAnnouncements.push(thread);
            } else {
                transformedPayload.announcements[thread] = processAnnouncementThread(announcement);
            }
        });

        _.forIn(payload.Messages, (message, thread) => {
            transformedPayload.messages[thread] = processMessageThread(message);
        });

        if (payload.InactiveUsers) {
            transformedPayload.deactivate = payload.InactiveUsers;
        }

        return { ...transformedPayload, lastActiveTS: payload.ServerTime };
    } catch (error) {
        // swallow the exception and let the api error handler take care of it.
    }
    return data;
};
